import React, { useRef, useState, useEffect } from "react";
import styles from "./HomeScreen.module.scss";

// components
import Card from "../../components/Card/Card";
import ClassPeriod from "../../components/ClassPeriod/ClassPeriod";
import Chart from "../../components/Chart/Chart";
import List from "../../components/List/List";

import { Calendar, ModalStudentsAttending } from "../../components";
import classNames from "classnames";
import { dateToString } from "../../utils/util";

//icons
import { ReactComponent as Checklist } from "../../assets/icons/checklist.svg";

import { useSelector, useDispatch } from "react-redux";
import { selectEvents } from "../../store/slices/events/slice";

import {
  fetchPeriodEventData,
  fetchBestWorstStudents,
} from "../../store/slices/periodEventData/asyncThunks";
import {
  selectPeriodEventData,
  selectWorstStudents,
  selectBestStudents,
} from "../../store/slices/periodEventData/slice";

const dataForChart = [
  {
    datasetvalue: 0,
    label: "22 Jun",
  },
  {
    datasetvalue: 0,
    label: "23 Jun",
  },
  {
    datasetvalue: 0,
    label: "24 Jun",
  },
  {
    datasetvalue: 0,
    label: "25 Jun",
  },
  {
    datasetvalue: 0,
    label: "26 Jun",
  },
  {
    datasetvalue: 0,
    label: "27 Jun",
  },
  {
    datasetvalue: 0,
    label: "28 Jun",
  },
];

const HomeScreen = () => {
  const [selectedStudents, setSelectedStudents] = useState(null);
  const [graph, setGraph] = useState([]);

  const refModalStudentsAtt = useRef();
  const dispatch = useDispatch();

  const { data } = useSelector(selectEvents);

  const periodEventsData = useSelector(selectPeriodEventData);
  const worstStudents = useSelector(selectWorstStudents);
  const bestStudents = useSelector(selectBestStudents);

  useEffect(() => {
    dispatch(fetchPeriodEventData({}));
  }, [dispatch]);

  useEffect(() => {
    if (periodEventsData.data.graph) {
      periodEventsData.data.graph.forEach((day, index) => {
        dataForChart[index].datasetvalue = parseInt(day.count * 100);
      });

      dataForChart.forEach((day, index) => {
        let date = new Date();
        date.setDate(date.getDate() - 1 - index);
        dataForChart[index].label = dateToString(date);
      });

      setGraph(dataForChart);
    }
  }, [periodEventsData]);

  useEffect(() => {
    dispatch(fetchBestWorstStudents({}));
  }, [dispatch]);

  return (
    <div className={styles.screenContainer}>
      <h1 className={styles.red}>Dashboard</h1>
      <div className={classNames([styles.screenContent, styles.flexRow])}>
        <div className={classNames([styles.flexItem33])}>
          {/* <Button
            onClick={() => refModalStudentsAtt.current.show()}
            title="Show Modal NewClass"
          ></Button> */}

          <Card calendar>
            <div className={classNames([styles.card])}>
              <Calendar />
              {data &&
                data.map((item, index) => (
                  <ClassPeriod
                    key={index}
                    {...item}
                    showRestStudents={(returnedData) => {
                      setSelectedStudents(returnedData);
                      refModalStudentsAtt.current.show();
                    }}
                  />
                ))}
            </div>
          </Card>
        </div>
        <div className={classNames([styles.flexItem66])}>
          <div
            className={classNames([styles.screenContent, styles.flexColumn])}
          >
            <Card>
              <div className={classNames([styles.card, styles.graph])}>
                <h2>Student participation %</h2>
                <Chart data={graph} />
              </div>
            </Card>

            <div className={classNames([styles.screenContent, styles.flexRow])}>
              <div className={classNames([styles.flexItem50])}>
                <Card calendar>
                  <div
                    className={classNames([
                      styles.card,
                      styles.regularyAttendingContainer,
                    ])}
                  >
                    <div className={classNames(styles.cyrcleOutside)}>
                      <div className={styles.cyrcleInside}>
                        {/* <Checklist className={classNames(styles.icon)} /> */}
                        <Checklist className={styles.icon} />
                      </div>
                    </div>
                    <div className={classNames(styles.regularyAttendingValues)}>
                      <div className={classNames(styles.attendigValues)}>
                        {periodEventsData.data.sumAll &&
                        periodEventsData.data.sumAll.length ? (
                          <p>{`${periodEventsData.data?.sumAll[0].count}/${periodEventsData.data?.sumAll[1].count}`}</p>
                        ) : (
                          "0/0"
                        )}

                        {/* <ArrowUp className={styles.iconGreen} /> */}
                      </div>
                      <span className={classNames(styles.attendigValuesText)}>
                        Average attendance
                      </span>
                    </div>
                    <div className={styles.percentageValue}>
                      {periodEventsData.data.sumAll &&
                      periodEventsData.data.sumAll.length
                        ? parseInt(
                            (periodEventsData.data?.sumAll[0].count /
                              periodEventsData.data?.sumAll[1].count) *
                              100
                          )
                        : 0}
                      %
                    </div>
                  </div>
                </Card>
              </div>
              {/* <div className={classNames([styles.flexItem50])}>
                <Card>
                  <div className={classNames([styles.card])}>right</div>
                </Card>
              </div> */}
            </div>

            {!!worstStudents.data.length && (
              <Card>
                <div className={classNames([styles.card])}>
                  <List
                    title="Least attending students"
                    items={worstStudents.data}
                    val={"least"}
                  />
                </div>
              </Card>
            )}

            {!!bestStudents.data.length && (
              <Card>
                <div className={classNames([styles.card])}>
                  <List
                    title="Most attending students"
                    items={bestStudents.data}
                    val={"most"}
                  />
                </div>
              </Card>
            )}
          </div>
        </div>
      </div>
      <ModalStudentsAttending
        title="List of students"
        modalRef={refModalStudentsAtt}
        students={selectedStudents}
      />
    </div>
  );
};

export default HomeScreen;
